var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7309 25.0827H15.3975V15.7377H19.6022L20.0642 11.0943H15.3975V8.74935C15.3975 8.43993 15.5205 8.14318 15.7393 7.92439C15.958 7.7056 16.2548 7.58268 16.5642 7.58268H20.0642V2.91602H16.5642C15.0171 2.91602 13.5334 3.5306 12.4394 4.62456C11.3455 5.71852 10.7309 7.20225 10.7309 8.74935V11.0943H8.39755L7.93555 15.7377H10.7309V25.0827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebookWhite);
export default __webpack_public_path__ + "static/media/Social_Facebook_White.0a1214d905202c24c41b5b4b5393d4f0.svg";
export { ForwardRef as ReactComponent };